import { AppContainer } from "@/components/layout/app-container"
import { ContractForm } from "../components/form-contrato/contract-form"
import { PDFPreview } from "../components/pdf-preview"
import { ActionButtonsContrato } from "../components/action-buttons"
import { useContratoForm } from "../hooks/use-contrato-form"

export function ContratosForm({ mode }: { mode: "add" | "edit" }) {
  const {
    form,
    equipe,
    isPending,
    submitAction,
    previewUrl,
    navigate,
    onSubmit,
    handleFileUpload,
    handleMemberChange,
    handleClosePreview,
    handleActionSubmit,
  } = useContratoForm({ mode })

  return (
    <AppContainer
      title={mode === "add" ? "Solicitar Contrato" : "Atualizar Contrato"}
      button={
        <ActionButtonsContrato
          navigate={() => navigate("/contratual/contratos")}
          isPending={isPending}
          submitAction={submitAction}
          onSave={() => handleActionSubmit("save")}
          onSend={() => handleActionSubmit("send")}
        />
      }
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 bg-[#15203c]">
        <ContractForm
          mode={mode}
          form={form}
          onSubmit={onSubmit}
          equipe={equipe}
          handleFileUpload={handleFileUpload}
          handleMemberChange={handleMemberChange}
        />

        <PDFPreview
          className="col-span-2"
          title={mode === "add" ? "Contrato" : "Pré-visualização"}
          subtitle={mode === "add" ? "Novo contrato" : "Pré-visualização do contrato"}
          pdfUrl={previewUrl}
          onClose={handleClosePreview}
        />
      </div>
    </AppContainer>
  )
}
